import { Dispatch, SetStateAction } from 'react';
import toast from 'react-hot-toast';
import { Slider } from "@mui/material";
import styled from "@emotion/styled";
import {
  hombres_15,
  hombres_20,
  hombres_25,
  hombres_30,
  hombres_35,
  hombres_40,
  hombres_45,
} from '../../Shared/Images/PorcentajeGrasa/prueba_hombres';

import {
  mujeres_15,
  mujeres_20,
  mujeres_25,
  mujeres_30,
  mujeres_35,
  mujeres_40,
  mujeres_45,
} from '../../Shared/Images/PorcentajeGrasa/prueba_mujeres';
import { Tr4inerContainedButton, Tr4inerOutlinedButton } from '../../Utils/Button';
import { IUserFromStorage } from '../../Interfaces/IUser';

export interface IEvaluacion {
  unidadPeso: string;
  porcentajeGrasa: number;
  peso: number;
  tipoActividad: string;
  objetivo: string;
  estaturaReal: number;
  sedeID: number;
  cantidadComidas: number;
  cantidadDiasEntrenamiento: number;
  tiempoEntrenamiento: string;
  mes: number;
  diasPrioridad: number;
}

export interface IPesoPorcentaje {
  unidadPeso: string;
  porcentajeGrasa: number;
  peso: number;
}

interface IAbrirModalConfirmar {
  files: string[];
  data: IEvaluacion;
  user: IUserFromStorage;
  sexo: boolean;
  setIsOpenModalConfirmar: Dispatch<SetStateAction<boolean>>;
}

export const getImageForValue = (value: number, sexo: boolean): string | null => {
  const imageMapmen = {
    15: hombres_15,
    20: hombres_20,
    25: hombres_25,
    30: hombres_30,
    35: hombres_35,
    40: hombres_40,
    45: hombres_45,
  };

  const imageMapwomen = {
    15: mujeres_15,
    20: mujeres_20,
    25: mujeres_25,
    30: mujeres_30,
    35: mujeres_35,
    40: mujeres_40,
    45: mujeres_45,
  };

  const imageMap = sexo ? imageMapmen : imageMapwomen;

  for (const [key, image] of Object.entries(imageMap)) {
    if (value <= Number(key)) {
      return image;
    }
  }

  return null;
};

export const marksPorcentaje = [
  // { value: 5, label: "5-9%", textLabel: "5-9%" },
  // { value: 10, label: "", textLabel: "10-14%" },
  { value: 15, label: '', textLabel: '15-19%' },
  { value: 20, label: '', textLabel: '20-24%' },
  { value: 25, label: '', textLabel: '25-29%' },
  { value: 30, label: '', textLabel: '30-34%' },
  { value: 35, label: '', textLabel: '35-39%' },
  { value: 40, label: '', textLabel: '40%' },
  { value: 45, label: '45%+', textLabel: '45%' },
];

export const CustomizedSlider = styled(Slider)({
  color: "#FF8B01",
  "& .MuiSlider-valueLabel": {
    backgroundColor: "black",
  },
});

export const abrirModalConfirmarEvaluacion = ({files, data, user, sexo, setIsOpenModalConfirmar}: IAbrirModalConfirmar) => {
  
  let err1 = false;
  let err2 = false;
  let err3 = false;
  let err4 = false;
  let err5 = false;
  // let err6 = false;
  // let err7 = false;

  if (user.esReto && files.length < 4) {
    err1 = true;
  } else if (!user.esReto && files.length < 3) {
    err1 = true;
  }
  if (data.peso <= 0) {
    if (data.porcentajeGrasa <= 14) {
      err2 = true;
      console.log(data.peso , data.porcentajeGrasa);
    } else {
      err3 = true;
      console.log(data.peso)
    }
  }
  if (data.peso > 0 && data.porcentajeGrasa <= 4) {
    return err4 = true;
  }

  
  if(data.diasPrioridad === undefined){
    err5 = true;
  }
  if( data.cantidadDiasEntrenamiento === 3 && data.diasPrioridad === 0 ){
    err5 = true;
  }
  if(data.cantidadDiasEntrenamiento === 4 && data.diasPrioridad === 0){
    err5 = true;
  }

  if(sexo){
    err5 = false;
  }

  if (err1) {
    toast.error(`Tienen que ser mínimo ${user.esReto ? 4 : 3} imágenes 😢.`);
    return;
  }
  if (err2) {
    toast.error('Por favor coloca tu peso y porcentaje de grasa');
  }
  if (err3) {
    toast.error('Por favor coloca tu peso');
  }
  if (err4) {
    toast.error('Por favor coloca tu porcentaje de grasa');
  }
  if(err5){
    toast.error('Por favor selecciona una opción de días de prioridad');
  }

  if (!err1 && !err2 && !err3 && !err4 && !err5) {
    setIsOpenModalConfirmar(true);
  }
}

interface IEvaluacionStepper {
  handleNext: () => void;
  setSection: Dispatch<SetStateAction<number>>;
}

//* Se le envia la imagen, el ratio de calidad [0-1], el ancho y alto máximo y el formato a transformar ("jpeg" o "webp")


export const EvaluacionStepper = ({handleNext, setSection} : IEvaluacionStepper) => {
  return (
    <div className="row flex mt-4">
      <div className="col-6 flex justify-content-end">
        <Tr4inerOutlinedButton
          variant="outlined"
          size="large"
          sx={{
            color: '#000',
            textTransform: 'capitalize',
            fontSize: '1.2rem',
            fontWeight: 'bold',
          }}
          onClick={() => {
            setSection((sec: number) => sec - 1);
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
        >
          {`Atrás`}
        </Tr4inerOutlinedButton>
      </div>
      <div className="col-6 flex justify-content-start">
        <Tr4inerContainedButton
          variant="contained"
          size="large"
          sx={{
            textTransform: 'capitalize',
            mr: 3,
            px: 4,
            fontSize: '1.2rem',
            fontWeight: 'bold',
          }}
          onClick={() => {
            handleNext();
          }}
        >
          {`Siguiente`}
        </Tr4inerContainedButton>
      </div>
    </div>
  )
}


